<script>
  import { base } from '$app/paths';
  import { onMount } from 'svelte';
  import content from '$locales/en/content.json';
  import {
    SEO,
    BodyText,
    Theme,
    Article,
  } from '@reuters-graphics/graphics-components';
  import Post from '$lib/Post.svelte';
  import { page } from '$app/stores';
  import { assets } from '$app/paths';
  import { goto } from '$app/navigation';
  import slugify from '$utils/slugify';
  import { isbot } from 'isbot';

  // Styles
  import '@reuters-graphics/graphics-components/scss/main.scss';
  import '$lib/styles/global.scss';
  import { dev } from '$app/environment';

  export let data;

  $: post = data.post;
  $: authors = post.authors.map((author) => ({
    name: author.trim(),
    link: `https://www.reuters.com/authors/${slugify(author)}/`,
  }));

  $: referralText = `Read more: [${content.story.seoTitle}](${base}/).`;

  onMount(async () => {
    if (navigator.webdriver || isbot(navigator.userAgent) || dev) return;
    await goto(`${base}/#${data.slug}`, { replaceState: true });
  });
</script>

<SEO
  lang="en"
  baseUrl={import.meta.env.BASE_URL}
  pageUrl={$page.url}
  seoTitle={post?.seoTitle || post?.title || content.story.seoTitle}
  seoDescription={post?.seoDescription || content.story.seoDescription}
  shareTitle={post?.shareTitle || post?.title || content.story.shareTitle}
  shareDescription={post?.shareDescription}
  shareImgPath={`${assets}/${post?.shareImgPath || content.story.shareImgPath}`}
  shareImgAlt={content.story.shareImgAlt}
  publishTime={post?.publishedDate}
  updateTime={post?.updatedDate}
  {authors}
/>

<Theme>
  <Article>
    {#if post}
      <Post content={post} />
    {/if}
    <BodyText text={referralText} />
  </Article>
</Theme>
